// @flow

import React from 'react';
import { I18n } from 'react-redux-i18n';
import type { History } from 'tab-router/dist/types';
import { HEADER_EVENTS } from '../../path/headerPaths';
import { buildQueryString, parseQueryParams } from '../../utils/urlUtils';

type Props = {
  slide: { name: string, url: string },
  currentBaseUrl: string,
  currentSlideUrl: string,
  history: History,
  location: Location,
  notifyInfoMallDisabledHeader: (header: string) => void,
  disabledNoDataTabs: string[],
}

function HeaderTab(props: Props) {
  const createSlideUrl = () => {
    // Remove params related to events navigation
    let locationSearch = props.location.search;
    if (props.slide.url !== HEADER_EVENTS) {
      const queryParams = parseQueryParams(locationSearch);
      queryParams.event = null;
      queryParams.opening = null;
      locationSearch = buildQueryString(queryParams);
    }
    // Construct new url
    return `${props.currentBaseUrl}${props.slide.url}${locationSearch}`;
  };

  const slideUrl = createSlideUrl();
  const isDisabled = props.disabledNoDataTabs.some((path: string) => slideUrl.includes(path));
  const isSelected = props.slide.url === props.currentSlideUrl;
  const slideName = I18n.t(props.slide.name);

  return (
    <button
      onClick={() => (!isDisabled
        ? props.history.push(slideUrl)
        : props.notifyInfoMallDisabledHeader(slideName))
      }
      className={`slider-element${isSelected ? ' selected' : ''}${isDisabled ? ' disabled' : ''}`}
      key={props.slide.url}
    >
      <div
        className="slider-status-indicator"
      />
      <div className="slider-element-title">{slideName}</div>
    </button>
  );
}

export default HeaderTab;
